import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { PropertiesSettings } from "../../core/configuration/properties-settings";
import { OperationsService } from '../../core/services/operations.service';
import {
  ControparteAssociativaAdapter
} from '../components/fascicolo/controparti-associativa-update/controparte-associativa-adapter';
import { Controparte } from '../models/controparte';
import { Parte } from '../models/parte';
import { Categoria } from '../models/tipologiche/categoria';
import { BaseForm } from './base-Form';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { Subscription } from 'rxjs';
import { Directive, OnDestroy } from '@angular/core';

declare var removeEmptyObject: any;
@Directive()
export abstract class AssociativaContropartiForm extends BaseForm  implements OnDestroy{
    readonly PROPERTIES_SETTINGS = PropertiesSettings;
    formControparte: Controparte;
    associativaForm: FormGroup;
    tipicategoriaOptions: Categoria[] = [];
    genericFascicolo: string;
    isPenale: boolean = false;
    parte: Parte;
    flagAttore: boolean;
    subscriptionModifica: Subscription;
    protected categoriaOriginale: string;


    constructor(private campiForm: FormBuilder, protected operationService: OperationsService, 
      private helpers: HelpersService, private activatedRoute: ActivatedRoute,
      private modalNotifyService: ModalNotifyService, private router: Router) {
      super();
      activatedRoute.params.subscribe( params => {
        this.genericFascicolo = params.genericFascicolo;
      });
      const url = this.router.url.toLowerCase();
      this.isPenale = url.includes('penale');
    }

    populateSelect() {
      if (this.tipicategoriaOptions.length === 0) {
        this.helpers.getCategorieControparte(this.genericFascicolo).subscribe(response => this.tipicategoriaOptions = response);
      }
    }

  createForm() {
    let controparte: Controparte = this.getControparte();
    if (this.parte) {
      controparte.parte = this.parte;
    }
    this.formControparte = new ControparteAssociativaAdapter(controparte).controparte;
    if(this.inserimento){
      this.formControparte.flagAttore = false;
    }
    if(!this.formControparte.dataAssociazione){
      this.formControparte.dataAssociazione=new Date().getTime();
    }
    this.associativaForm = this.campiForm.group({
      primario: [this.formControparte.primario],
      categoria: [this.formControparte.categoria],
     // dataAssociazione: [this.formControparte.dataAssociazione, Validators.required],
      ritirato: [this.formControparte.ritirato],
      cliente: [this.formControparte.cliente],
      dataTermine: [this.formControparte.dataTermine],
      note: [this.formControparte.note],
      flagAttore: [this.formControparte.flagAttore]
    });
  }

  update() {
    const nuovaCategoria = this.formControparte?.categoria?.label ?? '';
    console.log('categoriaOriginale',this.categoriaOriginale)
    if (!this.inserimento && this.isPenale && this.categoriaOriginale === 'INDAGATO/IMPUTATO' && nuovaCategoria !== 'INDAGATO/IMPUTATO') {
      // Mostro il messaggio di conferma
      this.subscriptionModifica = this.modalNotifyService.notifyConfirmObservable
        .subscribe(result => {
          if (result) {
            // Se l'utente conferma, procedo con la modifica
             this.getRequest(this.formControparte);
          }
          // In entrambi i casi, annullo la subscription dopo l'uso
          this.subscriptionModifica.unsubscribe();
        });
  
      // Mostro il messaggio di conferma
      this.modalNotifyService.modificaPartiConReatiMessage();
    } else {
      // Se la controparte non è 'INDAGATO/IMPUTATO', procedo con la modifica senza conferma
        this.getRequest(this.formControparte);
    }  
  }

  ngOnDestroy() {
    if(this.subscriptionModifica) this.subscriptionModifica.unsubscribe();
  }

  setParte(parte: Parte) {
    this.parte = parte;
  }

  setCategoriaOriginale(categoria: string): void {
    this.categoriaOriginale = categoria;
  }

  abstract getControparte(): Controparte;
  abstract getRequest(request: Controparte);
  abstract canCheckPrimary(): boolean;
}
